// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module__container___2dUgK","panels":"styles-module__panels___ZHR3x","title":"styles-module__title___9Wg9e","instructions":"styles-module__instructions___2UmDN"};